// extracted by mini-css-extract-plugin
export default {"cardBase":"PaperInsights_cardBase__oK11u","cardFixed":"PaperInsights_cardFixed__jKp2c","cardFail":"PaperInsights_cardFail__HhtUu"};